import React from 'react';
import AppRouter from './AppRouter';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './hooks/theme-hook';

const App = () => {
	return (
		<BrowserRouter>
			<ThemeProvider>
				<AppRouter />
			</ThemeProvider>
		</BrowserRouter>
	);
};

export default App;
